'use client'

import { Card, Spacer } from '@vinted/web-ui'
import { useInView } from 'react-intersection-observer'

import { isBundlingAvailable, itemPageViewEvent } from '@marketplace-web/bundles/items-bundle-data'
import { useSession } from '@marketplace-web/shared/session-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import BundleEntryBanner from '../BundleEntryBanner'
import { ItemPageShopBundlesBlockPluginModel } from '../../types'

type Props = {
  data: ItemPageShopBundlesBlockPluginModel
}

const ItemPageShopBundlesBlockPlugin = ({ data }: Props) => {
  const currentUserId = useSession().user?.id
  const { track } = useTracking()

  const {
    canBundle,
    closetCountdownEndDate,
    itemId,
    itemUserId,
    userItemCount,
    isUserHated,
    isUserHatesYou,
    bundleDiscount,
    canBuyItem,
  } = data

  const { ref } = useInView({
    onChange: inView => {
      if (!inView) return
      track(
        itemPageViewEvent({
          item_id: itemId.toString(),
          target: 'shop_bundle',
        }),
      )
    },
    triggerOnce: true,
  })

  const isViewingOwnProfile = itemUserId === currentUserId

  const showPlugin = isBundlingAvailable({
    canBundle,
    totalItemCount: userItemCount,
    isCurrentUserAuthenticated: !!currentUserId,
    closetCountdownEndDate,
    hasHateFromAnySide: isUserHated || isUserHatesYou,
    isViewingOwnProfile,
  })

  if (!showPlugin) return null

  const renderContent = () => (
    <BundleEntryBanner
      itemId={itemId}
      canBuyItem={canBuyItem}
      itemUserId={itemUserId}
      bundleDiscount={bundleDiscount}
      screen="item"
    />
  )

  return (
    <div ref={ref}>
      <Spacer size={Spacer.Size.Large} />
      <Card>
        <div className="u-overflow-hidden">{renderContent()}</div>
      </Card>
    </div>
  )
}

export default ItemPageShopBundlesBlockPlugin
